import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import { Alert, Grid, Paper } from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import TextInput from "../../../form-fields/text-input";
import SelectInput from "../../../form-fields/select-input";
import DateInput from "../../../form-fields/date-picker";
import DashBoardContainer from "../../../layout/dashboard-container";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import { FormLabel, FormValue, GridRow } from "./custom-form-grid";
import {
  generateReceipt,
  getBankArea,
  getBankDetails,
  getConcessionAmount,
  getCounterReceiptDetails,
  getModeOfPayments,
} from "../../../../services/generate-counter-receipt";
import TransactionDetailsTable from "./transaction-details-table";
import TransactionHistoryTable from "./transaction-history-table";
import { validationSchema } from "../../../../utils/validation-schema";
import { useFormik, FormikProvider, Form } from "formik";

import "./styles.css";
import Loader from "../../../loader/loader";
import FormButtons from "../buttons";
import CheckBoxInput from "../../../form-fields/checkbox-input";
import AlertMsg from "../../../common/alert";
import { useNavigate } from "react-router-dom";
import {
  calculateFinalPendingAmt,
  getBalanceAmt,
  getCurrentDate,
  getErrorMsg,
  isEmptyObj,
} from "../../../../utils/helpers";
import { showToastError, showToastSuccess } from "../../../common/toastHelper";

const GenerateReceipt = () => {
  const navigate = useNavigate();
  const initialState = {
    propertyNumber: "",
    propertyName: "",
    zoneName: "",
    gatName: "",
    ownerName: "",
    propertyAddress: "",
    shalakaPathakVasuli: false,
    address: "",
    receiptDate: getCurrentDate(),
    mobileNumber: "",
    modeOfPayment: "",
    pendingChequeAmount: "",
    chequeNumber: "",
    chequeDate: "",
    bankName: "",
    bankArea: "",
    concessionType: "",
    lblBalanceAmount: "",
    lblFajilbal: "",
    lblIllegalFajil: "",
    lblTotalAmt: "",
    txtPaidAmount: "",
    lblConsAmt: "",
    yearWiseBillLst: [],
  };
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
    validateOnBlur: true, // Validate on blur
    validateOnChange: true, // Validate on change
  });
  // Destructure setValues from formik object
  const { setValues } = formik;

  const lang = useSelector((state) => state.userDetails.lang);
  const [modeOfPayments, setModeOfPayments] = useState([]);
  const [banks, setBanks] = useState([]);
  const [banksArea, setBanksArea] = useState([]);
  const [receiptData, setReceiptData] = useState({
    lblTotalAmt: "",
    lblIllegalFajil: "",
    lblFajilbal: "",
    lblConsAmt: "",
    txtPaidAmount: "",
    lblBalanceAmount: "",
  });

  const [concessionTypes, setConcessionTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [isBankDisabled, setIsBankDisabled] = useState(true);
  useEffect(() => {
    if (
      formik.values.modeOfPayment === 1 ||
      formik.values.modeOfPayment === 4
    ) {
      setIsBankDisabled(true);
    } else {
      setIsBankDisabled(false);
    }
  }, [formik.values, formik.errors]);

  const handleBlur = async (e) => {
    const { name, value } = e.target;

    if (name === "propertyNumber" && value && !formik?.errors?.propertyNumber) {
      try {
        setError("");
        setValues(() => ({
          ...initialState,
          modeOfPayment: "",
          concessionType: "",
          bankName: "",
          propertyNumber: value,
        }));
        setLoading(true);
        const receiptData = await getCounterReceiptDetails(value);
        const {
          lblTotalAmt,
          lblIllegalFajil,
          lblFajilbal,
          lblConsAmt,
          txtPaidAmount,
          lblBalanceAmount,
        } = receiptData;

        setReceiptData({
          lblTotalAmt,
          lblIllegalFajil,
          lblFajilbal,
          lblConsAmt,
          txtPaidAmount,
          lblBalanceAmount,
        });
        // setLblConsAmt(receiptData.lblConsAmt);
        // Update Formik values, merging with previous values
        setValues((prevValues) => ({
          ...prevValues,
          ...receiptData,
          modeOfPayment: "",
          concessionType: "",
          bankName: "",
          // txtPaidAmount: "0",
        }));

        const [modeOfPaymentsData, banksData, banksAreaData] =
          await Promise.all([
            getModeOfPayments(),
            getBankDetails(),
            getBankArea(),
          ]);

        setModeOfPayments(modeOfPaymentsData);
        setBanks(banksData);
        setBanksArea(banksAreaData);

        const lstConcessionType = receiptData.lstConcessionType.map((item) => {
          return {
            label: item,
            value: item,
          };
        });
        setConcessionTypes(lstConcessionType);
        setLoading(false);
        // showToastSuccess();
      } catch (error) {
        showToastError(getErrorMsg(error));
        // console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    } else if (name === "propertyNumber" && value === "") {
      setValues(() => ({
        ...initialState,
        modeOfPayment: "",
        concessionType: "",
        bankName: "",
      }));
    }
  };

  const handleFieldChange = async (event) => {
    const { name, value } = event.target;
    if (name === "txtPaidAmount") {
      let newFinalPendingAmt = calculateFinalPendingAmt(receiptData, value);
      setValues((prevValues) => ({
        ...prevValues,
        txtPaidAmount: value,
        lblBalanceAmount: newFinalPendingAmt,
      }));
    } else if (name === "propertyNumber" && value === "") {
      setValues(() => ({
        ...initialState,
        modeOfPayment: "",
        concessionType: "",
        bankName: "",
      }));
    } else if (name === "concessionType" && value !== "") {
      // console.log("!!here", value);
      const body = {
        propertyCode: formik.values.propertyNumber,
        concessionType: value,
      };
      try {
        setLoading(true);
        setError("");
        const concessionAmtRes = await getConcessionAmount(body);
        showToastSuccess();
        let lblBalanceAmount;
        await setReceiptData((prevState) => {
          lblBalanceAmount = getBalanceAmt({
            ...prevState,
            lblConsAmt: concessionAmtRes.lblConsAmt,
          });
          return {
            ...prevState,
            lblConsAmt: concessionAmtRes.lblConsAmt,
            lblBalanceAmount: lblBalanceAmount,
            txtPaidAmount: lblBalanceAmount,
          };
        });
        formik.setFieldValue("lblConsAmt", concessionAmtRes.lblConsAmt);
        formik.setFieldValue("txtPaidAmount", lblBalanceAmount);
        formik.setFieldValue("lblBalanceAmount", lblBalanceAmount);
      } catch (error) {
        formik.setFieldValue("concessionType", "");
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    }
    // formik.handleChange(event);
  };

  const handleSubmit = async () => {
    formik.setTouched({
      propertyNumber: true,
      receiptDate: true,
      modeOfPayment: true,
      txtPaidAmount: true,
    });
    await formik.validateForm();
    if (isEmptyObj(formik.errors)) {
      const {
        txtPaidAmount = "",
        propertyCode = "",
        lblConsAmt = "",
        concessionType = "",
        lblFajilbal = "",
        lblIllegalFajil = "",
        lblBalanceAmount = "",
        modeOfPayment = "",
        receiptDate = "",
        shalakaPathakVasuli: chkPymnttRcvdBySP = "",
        mobileNumber = "",
        emailID = "",
        chequeDate = "",
        chequeNumber = "",
        bankName: bankId = "",
        zoneName = "",
        gatName = "",
      } = formik.values;

      const modeOfPaymentName = modeOfPayments.find(
        (item) => item.id === modeOfPayment
      );

      const data = {
        txtPaidAmount,
        propertyCode,
        lblConsAmt,
        concessionType,
        lblFajilbal,
        lblIllegalFajil,
        lblBalanceAmount: lblBalanceAmount.toString(),
        modeOfPayment: modeOfPaymentName ? modeOfPaymentName.name : "",
        receiptDate,
        chkPymnttRcvdBySP: chkPymnttRcvdBySP.toString(),
        mobileNumber,
        emailID,
        chequeNumber,
        chequeDate,
        bankId: bankId.toString(),
        zoneName,
        gatName,
      };

      try {
        setLoading(true);
        const res = await generateReceipt(data);
        showToastSuccess();
        setLoading(false);
        if (res.propertyBillReceiptNumber) {
          if (modeOfPayment === "EDC") {
            navigate(`/edc-receipt`);
          } else {
            navigate(
              `/PrintReceipt?receiptNo=${res.propertyBillReceiptNumber}&receiptType=BillReceipt`
            );
          }
        } else {
          showToastError();
        }
      } catch (error) {
        // setError(getErrorMsg(error));
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <DashBoardContainer>
      {loading && (
        <Loader
          message={`Loading Property Number: ${formik.values.propertyNumber}`}
        />
      )}
      {error && (
        <AlertMsg
          message={error}
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      <FormikProvider value={formik}>
        <Form>
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.PropertLevyReceipt[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.PropertyNumber[lang]} required />
                <FormValue
                  component={
                    <TextInput
                      name="propertyNumber"
                      onChange={handleFieldChange}
                      onBlur={handleBlur}
                      required
                    />
                  }
                />
                <FormLabel label={labels.PropertyName[lang]} />
                <FormValue component={formik.values.propertyName} />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.Zone[lang]} />
                <FormValue component={formik.values.zoneName} />
                <FormLabel label={labels.GroupNumber[lang]} />
                <FormValue component={formik.values.gatName} />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.NameHolder[lang]} />
                <FormValue component={formik.values.ownerName} />
                <FormLabel label={labels.Address[lang]} />
                <FormValue component={formik.values.propertyAddress} />
              </GridRow>
              <GridRow>
                <FormLabel />
                <FormValue component={""} />
                <FormLabel label="Shalakha pathakakadun Vasuli *" />
                <FormValue
                  component={<CheckBoxInput name="shalakaPathakVasuli" />}
                />
              </GridRow>

              <GridRow>
                <FormLabel label={labels.ReceiptDate[lang]} required />
                <FormValue
                  component={<DateInput name="receiptDate" required />}
                />
                <FormLabel label={labels.MobileNo[lang]} />
                <FormValue component={<TextInput name="mobileNumber" />} />
              </GridRow>

              <GridRow>
                <FormLabel label={labels.PaymentMode[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="modeOfPayment"
                      options={modeOfPayments}
                      required
                    />
                  }
                />
                <FormLabel label="Pending Cheque Amount" />
                <FormValue component={"-"} />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.ChequeNumber[lang]} />
                <FormValue
                  component={
                    <TextInput name="chequeNumber" disabled={isBankDisabled} />
                  }
                />
                <FormLabel label={labels.ChequeDate[lang]} />
                <FormValue
                  component={
                    <DateInput name="chequeDate" disabled={isBankDisabled} />
                  }
                />
              </GridRow>

              <GridRow>
                <FormLabel label={labels.BankName[lang]} />
                <FormValue
                  component={
                    <SelectInput
                      name="bankName"
                      options={banks}
                      disabled={isBankDisabled}
                    />
                  }
                />
                <FormLabel label={labels.BankArea[lang]} />
                <FormValue
                  component={
                    <SelectInput
                      name="bankArea"
                      options={banksArea}
                      disabled={isBankDisabled}
                    />
                  }
                />
              </GridRow>

              <GridRow>
                <FormLabel label={labels.ConcessionType[lang]} />
                <FormValue
                  component={
                    <SelectInput
                      name="concessionType"
                      options={concessionTypes}
                      onChange={handleFieldChange}
                    />
                  }
                />
              </GridRow>
            </Grid>
          </Paper>

          <GridRow>
            <TransactionDetailsTable
              reviewData={formik.values}
              handlePaidAmtChange={handleFieldChange}
            />
          </GridRow>

          <Grid container justifyContent="center" alignItems="center">
            <Grid
              item
              md={3}
              container
              justifyContent={{ md: "flex-end" }}
              alignItems="center"
              p={2}
            >
              <FormButtons
                // isValid={!(formik.isValid && formik.dirty)}
                handleSubmitButtonClick={handleSubmit}
                resetForm={() => {
                  formik.resetForm();
                  setError("");
                }}
                submitBtnLabel="Submit"
              />
            </Grid>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Alert severity="info" sx={{ mb: 2 }}>
              Note: Submit button will be enabled when all required fields
              marked as * are filled.
            </Alert>
          </Grid>
        </Form>
      </FormikProvider>
      <GridRow>
        <TransactionHistoryTable
          yearWiseBillLst={formik.values.yearWiseBillLst}
        />
      </GridRow>
    </DashBoardContainer>
  );
};

GenerateReceipt.propTypes = {};

export default GenerateReceipt;
